export const isEventTrackingRoute = (pathname: string): boolean => (
  !/^\/planning(?:\/|$)/.test(pathname)
);
